import { reactive } from "vue";
import { showSuccessMessage, showFailMessage } from "../utils";

export default function useVerificationModal(service, updateItemsList) {
  const data = reactive({
    isShown: false,
    shippingAccount: {},
    message: "",
    messageStatus: "",
    loading: false,
  });

  const getInstructionText = () => {
    const auth = data.shippingAccount && data.shippingAccount.auth;
    const method = auth && auth.pin_option;
    const phone = auth && auth.billing_phone;
    const email = auth && auth.billing_email;

    const messages = {
      sms: `A PIN code has been sent to ${phone} via SMS.`,
      email: `A PIN code has been sent to ${email}.`,
      call: `You will receive a phone call to ${phone} with your PIN code.`,
    };

    return messages[method] || "Please enter the PIN code you received.";
  };

  const openVerificationModal = (shippingAccount, showMessage = false) => {
    data.shippingAccount = shippingAccount;
    data.message = showMessage ? getInstructionText() : "";
    data.messageStatus = showMessage ? "success" : "";
    data.isShown = true;
    data.loading = false;
  };

  const closeVerificationModal = () => {
    data.carrier = {};
    data.message = "";
    data.messageStatus = "";
    data.isShown = false;
    data.loading = false;
  };

  const handleVerification = async (shippingAccount) => {
    try {
      clearVerificationMessage();
      data.loading = true;

      const updatedItem = await service.put(shippingAccount);
      updateItemsList(updatedItem);

      if (updatedItem.auth && updatedItem.auth.child_key && updatedItem.auth.child_secret) {
        await showSuccessMessage(data, "Account verified successfully!", 5000);
        setTimeout(() => {
          closeVerificationModal();
        }, 5000);
      } else {
        await showFailMessage(data, "Account verified failed!");
      }
    } catch (e) {
      const errorMessage = (e.response &&
              e.response.data &&
              e.response.data.error &&
              e.response.data.error.details) ||
          "Invalid PIN. Please try again.";
      await showFailMessage(data, errorMessage);
    } finally {
      data.loading = false;
    }
  };

  const resendPinCode = async (shippingAccount) => {
    try {
      clearVerificationMessage();
      data.loading = true;

      await service.put(shippingAccount);
      data.shippingAccount.auth.pin_option = shippingAccount.auth.pin_option;

      await showSuccessMessage(data, getInstructionText(), 5000);
    } catch (e) {
      const errorMessage = (e.response &&
              e.response.data &&
              e.response.data.error &&
              e.response.data.error.details) ||
          "Invalid PIN. Please try again.";
      await showFailMessage(data, errorMessage);
    } finally {
      data.loading = false;
    }
  };

  const clearVerificationMessage = () => {
    data.message = "";
    data.messageStatus = "";
  };

  return {
    data,
    openVerificationModal,
    closeVerificationModal,
    handleVerification,
    resendPinCode,
    clearVerificationMessage,
  };
}
